module.exports = __webpack_public_path__ + "img/hot.b44e8920.svg";